export enum QuestStatus {
    NEW = 1,
    IN_PROCESS = 2,
    IN_REVIEW = 3,
    DONE = 4,
    CANCELLED = 5,
    ON_HOLD = 6,
    ARCHIVED = 7,
    UNARCHIVED = 8,
    PLANNING = 9,
    DRAFT = 10
}

export enum Priority {
    LOW = 1,
    MEDIUM = 2,
    HIGH = 3,
    URGENT = 4
}

export enum QuestDelegationPriority {
    LOW = 2,
    MEDIUM = 5,
    HIGH = 8
}

/**
 * Gets the priority label name from a numeric value (1-10)
 * @param value - A number between 1 and 10 from the backend
 * @returns The label name (e.g., "Low", "Medium", "High", "Urgent")
 */
export function getPriorityLabel(value: number): string {
    if (value >= 1 && value <= 3) return 'Low';
    if (value >= 4 && value <= 6) return 'Medium';
    if (value >= 7 && value <= 10) return 'High';
    return String(value); // Fallback to showing the number if invalid
}
export enum QuestType {
    FEATURE = 1,
    BUG = 2
}

export enum QuestActivityType {
    MODIFICATIONS_REQUESTED = 1,
    SOLUTION_APPROVED = 2,
    DESCRIPTION_UPDATED = 3,
    SOLUTION_SUBMITTED = 4,
    STATUS_CHANGED = 5,
    QUEST_CREATED = 6,
    RATING_SUBMITTED = 7,
    IMPLEMENTATION_PLAN_SUBMITTED = 8,
    IMPLEMENTATION_PLAN_MODIFIED = 9,
    IMPLEMENTATION_PLAN_APPROVED = 10,
    IMPLEMENTATION_PLAN_REJECTED = 11,
    WORK_STARTED = 13,
    WORK_SOLVED = 14,
    WORK_CANCELLED = 15,
    WORK_SOLUTION_RATING = 16,
    WORK_RESERVED = 17,
    NET_TIME_CALCULATED = 18,
    WORK_DESERTED = 19,
    PRIORITY_CHANGED = 20,
    QUEST_BREAKDOWN_SUBMITTED = 21,
    PLANNING_OFFLOADED = 22,
    BEEHIVE_EXPERT_REVIEW = 23,
    QUEST_MERGED = 24
}
